import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { forwardRef } from "react";
import { useTheme } from "../../../theme/utils/useTheme";
import { MultiLineTooltipSubtextStyled, MultiLineTooltipTitleStyled } from "../styled/MultilineTooltipDeprecatedStyled";

/**
 * @deprecated Please use TooltipTitle inside a TooltipBody instead. This gives the Tooltip
 * component more flexibility in its composition.
 */
export const MultiLineTooltipTitle = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(MultiLineTooltipTitleStyled, _extends({}, rest, {
    themeMode: themeMode,
    ref: ref
  }), children);
});
MultiLineTooltipTitle.displayName = "MultiLineTooltipTitle";

/**
 * @deprecated Please use TooltipMultilineText inside a TooltipBody instead. This gives the Tooltip
 * component more flexibility in its composition.
 */
export const MultiLineTooltipSubtext = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    children,
    ...rest
  } = _ref2;
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(MultiLineTooltipSubtextStyled, _extends({}, rest, {
    themeMode: themeMode,
    ref: ref
  }), children);
});
MultiLineTooltipSubtext.displayName = "MultiLineTooltipSubtext";
//# sourceMappingURL=MultilineTooltipDeprecated.js.map